require('./lbPoiSelect.scss');

const $inject = [];

const lbPoiSelect = {
  controller: 'lbPoiSelectCtrl as vm',
  template: require('./lbPoiSelect.html'),
  bindings: {
    name: '@',
    location: '=',
    defaultOptions: '<?',
    required: '<',
    disabled: '<',
    showLoader: '<',
    disablePlaceholder: '<',
    placeholdertext: '@',
    iconClassName: '<?',
    searchtypes: '@',
    onSelect: '&',
    originalCompanyLocations: '=',
    companyLocationsOnly: '<',
    disableGroupBy: '@',
  },
};

lbPoiSelect.$inject = $inject;

export default lbPoiSelect;



// WEBPACK FOOTER //
// ./src/components/lbPoiSelect/lbPoiSelect.js